import { api } from './client.js';

const unwrap = (r) => r.data?.data;

export const crmApi = {
  // Companies + contacts
  companies: (params) => api.get('/crm/companies', { params }).then(unwrap),
  createCompany: (payload) => api.post('/crm/companies', payload).then(unwrap),
  contacts: (params) => api.get('/crm/contacts', { params }).then(unwrap),
  createContact: (payload) => api.post('/crm/contacts', payload).then(unwrap),

  // Pipelines + deals
  pipelines: () => api.get('/crm/pipelines').then(unwrap),
  pipelineBoard: (id) => api.get(`/crm/pipeline/${id}`).then(unwrap),
  deals: (params) => api.get('/crm/deals', { params }).then(unwrap),
  getDeal: (id) => api.get(`/crm/deals/${id}`).then(unwrap),
  createDeal: (payload) => api.post('/crm/deals', payload).then(unwrap),
  updateDeal: (id, patch) => api.patch(`/crm/deals/${id}`, patch).then(unwrap),
  changeStage: (id, payload) => api.put(`/crm/deals/${id}/stage`, payload).then(unwrap),

  // Activities, quotations, contracts
  dealActivities: (id) => api.get(`/crm/deals/${id}/activities`).then(unwrap),
  logDealActivity: (id, payload) => api.post(`/crm/deals/${id}/activities`, payload).then(unwrap),
  createQuotation: (payload) => api.post('/crm/quotations', payload).then(unwrap),
  dealQuotations: (id) => api.get(`/crm/deals/${id}/quotations`).then(unwrap),
  getQuotation: (id) => api.get(`/crm/quotations/${id}`).then(unwrap),
  generateQuotePdf: (id) => api.post(`/crm/quotations/${id}/pdf`).then(unwrap),
  sendQuotation: (id) => api.post(`/crm/quotations/${id}/send`).then(unwrap),
  createContract: (payload) => api.post('/crm/contracts', payload).then(unwrap),
  dealContracts: (id) => api.get(`/crm/deals/${id}/contracts`).then(unwrap),
  signContract: (id) => api.post(`/crm/contracts/${id}/sign`).then(unwrap),

  convertDealToProject: (id, payload) => api.post(`/crm/deals/${id}/convert-to-project`, payload).then(unwrap),
};
